export const sortAscendingLabel = "q$Iz2c";
export const sortDescendingLabel = "ehwpte";
export const fromColumnLabel = "k$MCoc";
export const toColumnLabel = "PN6c3b";
export const subjectColumnLabel = "GRqhzd";
export const receivedColumnLabel = "JhTb7";
export const sentColumnLabel = "kQydGb";
export const returnTimeColumnLabel = "dD1RQd";
export const modifiedColumnLabel = "DuwSFd";
export const columnHeaderAriaLabel = "MZnM5d";
export const resizeButtonLabel = "AUgtpc";
export const categoryColumnLabel = "wFie$";
export const importanceColumnLabel = "iZjZcd";
export const priorityColumnLabel = "gE1GTe";
export const flagDueDateColumnLabel = "y4bFrd";
export const sizeColumnLabel = "RRLQye";
export default {sortAscendingLabel,sortDescendingLabel,fromColumnLabel,toColumnLabel,subjectColumnLabel,receivedColumnLabel,sentColumnLabel,returnTimeColumnLabel,modifiedColumnLabel,columnHeaderAriaLabel,resizeButtonLabel,categoryColumnLabel,importanceColumnLabel,priorityColumnLabel,flagDueDateColumnLabel,sizeColumnLabel};